var appDetail = {
    // 文章详情展开全文
	articleShowmore: function() {
		var artWrap = $('#showmoreArticleWrap');
		if (!artWrap.length) return false;
		var btn = $('#showmoreArticleBtn'); // 展开按钮
		var winHeight = $(window).height();
		var imgLength = artWrap.find("img").length;
		// 判断文章是否大于可见区域
		if(artWrap.height() > winHeight * 1 || imgLength > 3){
			artWrap.addClass('show_after').css('height', winHeight * 1);
			btn.show();
		}
		btn.on('click', function() {
			$(this).hide();
			artWrap.removeClass('show_after').css('height', 'auto');
		})
	}
}
$(function () {
    //遍历执行appDetail中的方法
    for (var key in appDetail) {
        typeof appDetail[key] == 'function' && appDetail[key]();
    }
});